/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        materials : [],
        nomenklatura : [],
        materialPrihodList : [],
        prihodForReport : [],
    },

    methods : {

    },

    getters : {
        getPrihodReport(state) {
            return state.prihodForReport;
        },

        getPrihodByIndex: state => index => {
            return state.materialPrihodList[index];
        },

        prihodList(state) {
            return state.materialPrihodList;
        },

        getNomenklatura(state) {
            return state.nomenklatura;
        },

        getNomenklaturaById: state => id => {
            return state.nomenklatura.find(item => item.id == id);
        },

        getNomenklaturaByType: state => id => {
            return state.nomenklatura.filter(item => item.type_id == id);
        },


        getAllMaterials(state) {
            return state.materials;
        },

        getMaterialById: state => id => {
            return state.materials.find(item => item.id == id);
        },

        getMaterialsByDirection: state => d => {
            return state.materials.filter(item => item.directions.indexOf(d) > -1);
        },

    },

    mutations: {
        
        setPrihodReport(state, data) {
            state.prihodForReport = data;
        },

        updateOneNomeklatura(state, data) {
            const index =  state.nomenklatura.findIndex(item => item.id === data.id); // ищем индекс редактируемой записи
            if (index>-1)  state.nomenklatura.splice(index, 1, data); //заменяем запись
            else state.nomenklatura.push(data);
        },

        updateNomenklatura(state, data) {
            data.forEach(element => {
                const index =  state.nomenklatura.findIndex(item => item.id === element.id); // ищем индекс редактируемой записи
                if (index>-1)  state.nomenklatura.splice(index, 1, element); //заменяем запись
                else state.nomenklatura.push(element);
            });
        },
        
        deleteFromPrihodList(state, index) {
            state.materialPrihodList.splice(index, 1);
        },

        addMaterialInList(state, material) {
            state.materialPrihodList.push(material);
        },

        clearMaterialsInList(state){
            state.materialPrihodList.splice(0, state.materialPrihodList.length);
        },

        deleteNomenklatura(state, id) {
            const index =  state.nomenklatura.findIndex(item => item.id === id);
            state.nomenklatura.splice(index, 1);
        },

        deleteMaterial(state, id) {
            const index =  state.materials.findIndex(item => item.id === id);
            state.materials.splice(index, 1);
        },

        setMaterials(state, materials) {
            state.materials = materials;
        },

        addNewMaterial(state, material) {
            state.materials.push(material);
        },
        
        saveMaterial(state, material) {
            const index =  state.materials.findIndex(item => item.id === material.id); // ищем индекс редактируемой записи
            state.materials.splice(index, 1, material); //заменяем запись
        },

        setNomenklatura(state, data) {
            state.nomenklatura = data;
        },

        saveNomenklatura(state, data) {
            const index =  state.nomenklatura.findIndex(item => item.id === data.id); // ищем индекс редактируемой записи
            state.nomenklatura.splice(index, 1, data); //заменяем запись
        },

        addNomenklatura(state, data){
            state.nomenklatura.push(data);
        },
    },

    actions : {
        getMaterialPrihod({state, commit, rootState, rootGetters}, period) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.post('/prihodList', period)
                .then(response => {
                    commit('setPrihodReport', response.data);
                })
                .catch(error => {
                    reject(error);
                })
            });
        },

        addNewPrihod({state,  commit, rootState, rootGetters}, postavshik) {
            
            return new Promise((resolve, reject) => {

                axios.post('/add_materials', {'postavshik' : postavshik, data : state.materialPrihodList})
                .then(response => {

                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateNomenklatura', 'content' : response.data});
                    resolve(response.data);

                })
                .catch(error => {
                    reject(error)
                });
            });

        },

        saveNomenklatura(context, material) {

            return new Promise((resolve, reject) => {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/materials/'+ material.id, material)
                .then(response => {
                    
                    if (material.id >-1) {context.commit('saveNomenklatura', response.data);} //если редактируем 
                    else {context.commit('addNomenklatura', response.data);} //если добавляем

                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },

        deleteNomenklatura(context, material) {

            return new Promise((resolve, reject) => {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.delete('/materials/'+ material.id, material)
                .then(response => {
                    context.commit('deleteNomenklatura', material.id);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });


        },

        getNomenklatura({dispatch, commit, rootState}) {

            return new Promise((resolve, reject) => {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.get('/materials')
                .then(response => {
                    commit('setNomenklatura', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        console.log(error);
                    }
                    else {
                        let t = error.response.status == 429 ? 15000 : 1500;    
                        if (error.response != undefined)
                            if (error.response.headers["retry-after"]!= undefined) t = error.response.headers["retry-after"];
                        setTimeout(()=>{        // повторная загрузка 
                            dispatch('getNomenklatura');
                        }, t);
                    }
                    reject(error.response.status);
                });
            });


        },
        getMaterials({dispatch, commit, rootState}) {

            return new Promise((resolve, reject) => {

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                    axios.get('/types')
                    .then(response => {
                        commit('setMaterials', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;    
                            if (error.response != undefined)
                                if (error.response.headers["retry-after"]!= undefined) t = error.response.headers["retry-after"];
                                setTimeout(()=>{        // повторная загрузка 
                                    dispatch('getMaterials');
                                }, t);
                        }
                        reject(error.response.status);
                    });
            });
        },

        deleteMaterial(context, material_id) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.delete('/types/'+material_id, {
                    id:material_id
                })
                .then(response => {
                    context.commit('deleteMaterial', material_id);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },

        saveMaterial(context, material) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/types', material)
                .then(response => {
                    if (material.id ==-1) context.commit('addNewMaterial', response.data);
                    else context.commit('saveMaterial', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            }); 
        },

        correctMaterial({rootGetters, rootState}, data) {

            return new Promise((resolve, reject) => {
                axios.post('/correction', data)
                .then(response => {
                    // if (material.id ==-1) context.commit('addNewMaterial', response.data);
                    // else context.commit('saveMaterial', response.data);
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateNomenklatura', 'content' : response.data});
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            }); 
        },

    }

}